// extracted by mini-css-extract-plugin
module.exports = {"logo":"logo_logo__q6bk_","logo__wrapper":"logo_logo__wrapper__yf2Sx","logo__bg":"logo_logo__bg__tCIe6","logo__text":"logo_logo__text__E3qx9"};